<template>
  <div>
    <div class="reporting-selection__row mx-2" :class="justify">
      <treeselect
        :model-value="selections"
        data-id-e2e="reportingBundleWorkpackageSelect"
        class="vue-treeselect-custom-tree mr-2 w-70 vue-treeselect--values-hidden"
        multiple
        :options="options"
        :placeholder="`${t('reportingPage.totalItemsSelected')}: ${totalSelected}`"
        :default-expand-level="1"
        :no-results-text="t('reportingPage.noResults')"
        :no-options-text="noOptionsMessage"
        search-nested
        disable-fuzzy-matching
        :clearable="false"
        value-consists-of="LEAF_PRIORITY"
        @select="addSelection"
        @deselect="removeSelection"
        @close="changeSelections"
      >
        <template #before-list>
          <header class="vue-treeselect__header d-flex">
            <span v-if="bundlesEnabled" class="vue-treeselect__heading">
              {{ t('reportingPage.selectionHeaders.bundles') }}
            </span>
            <span class="vue-treeselect__heading">
              {{ t('reportingPage.selectionHeaders.workpackages') }}
            </span>
          </header>
        </template>

        <template #option-label="optionLabel">
          <label :class="optionLabel.labelClassName">
            <!-- displays the tooltip if the lable is bigger than 25 chars -->
            <v-tooltip location="top" :disabled="optionLabel.node.label.length < truncateThreshold">
              <template #activator="{ props }">
                <span v-bind="props">
                  {{ optionLabel.node.label }}
                </span>
              </template>
              <span>{{ optionLabel.node.label }}</span>
            </v-tooltip>
          </label>
        </template>
      </treeselect>
      <DocsLink :link="docsLink" />
    </div>
  </div>
</template>

<script>
import Treeselect from 'vue3-treeselect';
import 'vue3-treeselect/dist/vue3-treeselect.css';
import { useContextStore } from '@/stores/context';
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  components: { Treeselect },

  props: {
    docsLink: {
      type: String,
      required: false,
      default: 'toolguide/140-extracts.html',
    },

    totalSelected: {
      type: Number,
      required: true,
      default: 0,
    },

    selections: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    options: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },

    justify: {
      type: String,
      required: false,
      default: 'justify-start',
    },
  },

  emits: ['onAddSelection', 'onRemoveSelection', 'onChangeSelections'],

  setup(props, { emit }) {
    const { t } = useInternationalization('compoundExtractsPage.table');
    const contextStore = useContextStore();

    const addSelection = selection => {
      emit('onAddSelection', selection);
    };
    const removeSelection = selection => {
      emit('onRemoveSelection', selection);
    };
    const changeSelections = () => {
      emit('onChangeSelections');
    };

    return {
      bundlesEnabled: contextStore.bundlesEnabled,
      t,
      addSelection,
      removeSelection,
      changeSelections,
    };
  },

  data() {
    return { truncateThreshold: 25 };
  },

  computed: {
    noOptionsMessage() {
      const key = this.bundlesEnabled ? 'noBundlesAvaialable' : 'noWorkpackagesAvaialable';
      return this.t(`reportingPage.${key}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.reporting-selection {
  box-sizing: border-box;
  display: flex;
  flex: 0;
  height: 36px;
  margin-bottom: 4px;
  padding: 8px 0;

  &__row {
    align-items: center;
    display: flex;
    height: 100%;
  }

  .v-toolbar__title {
    font-size: 1.2rem;
    font-weight: bold;
  }
}

.span-text {
  font-size: 1.4rem;
  font-weight: 600;
  color: $assortment-text-colour;
}

.sidebar-toggle-button {
  width: 32px;
  height: 32px !important;
}
</style>
